import { Client } from "~/types/client";

export const clients: Client[] = [
  {
    id: "1",
    name: "Petrobras Distribution",
    email: "contact@petrobras.com",
    phone: "+55 21 3224-1560",
    company: "Petrobras S.A.",
    creditScore: 92,
    riskScore: 15,
    paymentHistory: "good",
    isActive: true,
    address: "Av. República do Chile, 65 - Centro, Rio de Janeiro",
  },
  {
    id: "2",
    name: "Shell Retailers",
    email: "retail@shell.com",
    phone: "+31 70 377 9111",
    company: "Royal Dutch Shell",
    creditScore: 88,
    riskScore: 22,
    paymentHistory: "good",
    isActive: true,
    address: "Carel van Bylandtlaan 30, The Hague, Netherlands",
  },
  {
    id: "3",
    name: "ExxonMobil Supplies",
    email: "supplies@exxon.com",
    phone: "+1 972-444-1000",
    company: "ExxonMobil Corporation",
    creditScore: 95,
    riskScore: 12,
    paymentHistory: "good",
    isActive: true,
    address: "5959 Las Colinas Boulevard, Irving, Texas",
  },
  {
    id: "4",
    name: "Chevron Distributors",
    email: "dist@chevron.com",
    phone: "+1 925-842-1000",
    company: "Chevron Corporation",
    creditScore: 90,
    riskScore: 18,
    paymentHistory: "good",
    isActive: true,
    address: "6001 Bollinger Canyon Road, San Ramon, California",
  },
  {
    id: "5",
    name: "BP Retail Solutions",
    email: "retail@bp.com",
    phone: "+44 20 7496 4000",
    company: "BP p.l.c.",
    creditScore: 85,
    riskScore: 28,
    paymentHistory: "average",
    isActive: true,
    address: "1 St James's Square, London, United Kingdom",
  },
  {
    id: "6",
    name: "TotalEnergies Marketing",
    email: "marketing@totalenergies.com",
    phone: "+33 1 47 44 45 46",
    company: "TotalEnergies SE",
    creditScore: 89,
    riskScore: 20,
    paymentHistory: "good",
    isActive: true,
    address: "2 Place Jean Millier, La Défense, France",
  },
  {
    id: "7",
    name: "ConocoPhillips Ventures",
    email: "ventures@conocophillips.com",
    phone: "+1 281-293-1000",
    company: "ConocoPhillips",
    creditScore: 87,
    riskScore: 25,
    paymentHistory: "average",
    isActive: true,
    address: "925 N. Eldridge Parkway, Houston, Texas",
  },
  {
    id: "8",
    name: "Eni Global Markets",
    email: "markets@eni.com",
    phone: "+39 06 598 21",
    company: "Eni S.p.A.",
    creditScore: 82,
    riskScore: 30,
    paymentHistory: "average",
    isActive: true,
    address: "Piazzale Enrico Mattei, 1, Rome, Italy",
  },
  {
    id: "9",
    name: "Valero Refining",
    email: "refining@valero.com",
    phone: "+1 210-345-2000",
    company: "Valero Energy Corporation",
    creditScore: 80,
    riskScore: 35,
    paymentHistory: "average",
    isActive: true,
    address: "One Valero Way, San Antonio, Texas",
  },
  {
    id: "10",
    name: "Marathon Petroleum",
    email: "retail@marathonpetroleum.com",
    phone: "+1 419-422-2121",
    company: "Marathon Petroleum Corporation",
    creditScore: 83,
    riskScore: 32,
    paymentHistory: "average",
    isActive: true,
    address: "539 South Main Street, Findlay, Ohio",
  },
  {
    id: "11",
    name: "Phillips 66 Outlets",
    email: "outlets@phillips66.com",
    phone: "+1 281-293-6600",
    company: "Phillips 66",
    creditScore: 79,
    riskScore: 38,
    paymentHistory: "average",
    isActive: true,
    address: "2331 CityWest Blvd, Houston, Texas",
  },
  {
    id: "12",
    name: "Repsol Distribution",
    email: "distribution@repsol.com",
    phone: "+34 91 753 81 00",
    company: "Repsol S.A.",
    creditScore: 81,
    riskScore: 34,
    paymentHistory: "average",
    isActive: true,
    address: "C. de Méndez Álvaro, 44, Madrid, Spain",
  },
  {
    id: "13",
    name: "Sinopec International",
    email: "international@sinopec.com",
    phone: "+86 10 5976 1111",
    company: "China Petroleum & Chemical Corporation",
    creditScore: 77,
    riskScore: 40,
    paymentHistory: "average",
    isActive: true,
    address: "22 Chaoyangmen North Street, Beijing, China",
  },
  {
    id: "14",
    name: "PetroChina Exports",
    email: "exports@petrochina.com",
    phone: "+86 10 5998 6000",
    company: "PetroChina Company Limited",
    creditScore: 75,
    riskScore: 42,
    paymentHistory: "poor",
    isActive: true,
    address: "9 Dongzhimen North Street, Beijing, China",
  },
  {
    id: "15",
    name: "Lukoil Trading",
    email: "trading@lukoil.com",
    phone: "+7 495 627-44-44",
    company: "Lukoil",
    creditScore: 73,
    riskScore: 45,
    paymentHistory: "poor",
    isActive: true,
    address: "11 Sretensky Boulevard, Moscow, Russia",
  },
];
